<script lang="ts">
	/**
	 * A list of entries while it loads — an icon, a name over a detail line, a badge at the end —
	 * the shape every account list on `/Account` draws its rows in.
	 */
	import Bone from './Bone.svelte';

	export let rows: number = 3;
</script>

<ul role="status" aria-label="Loading" class="space-y-2 animate-pulse">
	{#each Array(rows) as _row, index (index)}
		<li class="widget bg-depth flex items-center gap-3">
			<Bone class="w-8 h-8 shrink-0" round="xl" />
			<div class="grow space-y-2">
				<Bone class="h-3 w-1/3" />
				<Bone class="h-2.5 w-1/2" />
			</div>
			<Bone class="h-5 w-16 shrink-0" />
		</li>
	{/each}
</ul>
